import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionId = hash.split('session_id=')[1]?.split('&')[0];

        if (!sessionId) {
          toast.error('Sesión inválida');
          navigate('/', { replace: true });
          return;
        }

        // Exchange session_id for user data
        const response = await fetch(`${API}/auth/session?session_id=${sessionId}`, {
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error('Error al procesar sesión');
        }

        const data = await response.json();
        toast.success(`¡Bienvenido, ${data.user.name}!`);
        
        // Navigate to dashboard (don't pass user in state to avoid clone errors)
        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Error de autenticación');
        navigate('/', { replace: true });
      }
    };

    processSession();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="animate-pulse text-primary font-heading text-2xl mb-4">
          PROCESANDO...
        </div>
        <p className="text-muted-foreground">Iniciando sesión con Google</p>
      </div>
    </div>
  );
}
